import React, { useState, useEffect, useRef } from 'react'
import { Button, ButtonGroup } from 'react-bootstrap'

function BooleanFilterPopover({ column, params, setParams, onClose, onSetHandleApply, canEdit = true, hideApplyButton = false }) {
  const accessorKey = column.accessor_key
  const [currentValue, setCurrentValue] = useState(params[accessorKey] || '')

  // Track initial value to detect changes
  const initialValue = useRef(params[accessorKey] || '')

  const handleValueChange = (value) => {
    if (!canEdit) return
    setCurrentValue(value)
  }

  const handleApply = () => {
    // Only update params if value has changed
    if (currentValue !== initialValue.current) {
      setParams((p) => ({ ...p, [accessorKey]: currentValue }))
    }
    onClose()
  }

  useEffect(() => {
    if (onSetHandleApply) {
      onSetHandleApply(handleApply)
    }
  }, [currentValue]) // eslint-disable-line react-hooks/exhaustive-deps

  // Auto-apply changes when hideApplyButton is true
  useEffect(() => {
    if (hideApplyButton) {
      setParams((p) => ({ ...p, [accessorKey]: currentValue }))
    }
  }, [currentValue, hideApplyButton, setParams, accessorKey])

  const handleClear = () => {
    setCurrentValue('')
    setParams((p) => ({ ...p, [accessorKey]: '' }))
  }

  // Determine the filter state
  const isOff = currentValue === ''
  const isTrue = currentValue === 'true' || currentValue === true
  const isNo = currentValue === 'not_true'

  return (
    <div>
      <div className="mb-3">
        <strong>{column.name}</strong>
      </div>

      <div className="mb-3">
        <div className="mb-2">
          <strong className="small">Filter</strong>
        </div>
        <ButtonGroup className="w-100">
          <Button
            variant={isOff ? 'primary' : 'light'}
            size="sm"
            onClick={() => handleValueChange('')}
            disabled={!canEdit}
          >
            Off
          </Button>
          <Button
            variant={isTrue ? 'primary' : 'light'}
            size="sm"
            onClick={() => handleValueChange('true')}
            disabled={!canEdit}
          >
            Yes
          </Button>
          <Button
            variant={isNo ? 'primary' : 'light'}
            size="sm"
            onClick={() => handleValueChange('not_true')}
            disabled={!canEdit}
          >
            No
          </Button>
        </ButtonGroup>
        <div className="mt-2 small text-muted">
          {isOff && 'No filter applied'}
          {isTrue && 'Show only checked'}
          {isNo && 'Show only unchecked'}
        </div>
      </div>

      {!hideApplyButton && (
        <div className="d-flex justify-content-between gap-2">
          {canEdit && (
            <Button variant="light" size="sm" onClick={handleClear}>
              Clear
            </Button>
          )}
          <Button variant="primary" size="sm" onClick={canEdit ? handleApply : onClose}>
            {canEdit ? 'Apply' : 'Close'}
          </Button>
        </div>
      )}
    </div>
  )
}

export default BooleanFilterPopover
